<template>
    <div>
        <table>
            <thead>
            <tr>
                <th :colspan="fields.length" class="text-center">Title</th>
            </tr>
            <tr>
                <th v-for="(field, index) in fields" :key="index">
                    {{ field }}
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in data" :key="index">
                <td
                    v-for="(col, r_index) in getFields(item)"
                    :key="r_index"
                    v-text="col"
                ></td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
                <th v-for="(field, index) in fields" :key="index">
                    {{ field }}
                </th>
            </tr>
            </tfoot>
        </table>
    </div>
</template>
<script>
import jQuery from "jquery";
import tools from "../library/tools";

export default {
    data() {
        return {
            fields: [],
            data: [],
        };
    },
    mounted() {
        tools.range(5).forEach((index) => {
            this.fields.push(`field${index}`);
        });
        tools.range(20).forEach((index) => {
            let row = {};
            this.fields.map((key) => {
                row[key] = `${key} - ${tools.dummyString()}`;
            });
            this.data.push(row);
        });

        this.$nextTick(() => {
            jQuery(this.$el.querySelectorAll("table")).DataTable({
                autoWidth: false,
            });
        });
    },
    methods: {
        getFields(row) {
            return Object.keys(row).map((field) => row[field]);
        },
    },
};
</script>
<style>
</style>
